import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBocholt() {
  return (
    <CityPageTemplate
      city="Bocholt"
      slug="bocholt"
      intro="Bocholt als westfälische Textilstadt am Niederrhein – wir weben ein solides finanzielles Fundament für Dich."
      description="Unabhängige & digitale Finanzberatung für Bocholt: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
